export const MONTHLY_DAY_RANGES = {
    min: 1,
    max: 29
}

export const BIWEEKLY_DAY_RANGES = {
    min: 0,
    max: 14
}

export const MONTH_WEEKS = [1, 2, 3, 4];
export const FOURTEEN_WEEKS = [1, 2];
export const WEEK_DAYS = [
    { day: 1, name: 'Lunes' },
    { day: 2, name: 'Martes' },
    { day: 3, name: 'Miércoles' },
    { day: 4, name: 'Jueves' },
    { day: 5, name: 'Viernes' },
    { day: 6, name: 'Sábado' },
];

export const PERIODICITY_CONTROLS_BY_TYPE: {[key: number]: string[]} = {
    // Día del mes (Mensual)
    1: ['day'],
    // Número de la semana (Mensual)
    2: ['week_number', 'weekday'],
    // Días antes del termino del mes (Mensual)
    3: ['day'],
    // Días antes del fin de quincena (Quincenal)
    4: ['day'],
    // Número de la semana (Catorcenal)
    5: ['week_number', 'weekday'],
    // Día de la semana (Semanal)
    6: ['weekday']
}
